// data.ts

export interface NavItem {
  label: string;
  link: string;
  megaMenu: {
    heading: string;
    href: string;
    links: {
      label: string; // Display text
      href: string; // URL
      target?: string; // Optional, e.g., "_blank"
      icon?: string; // Optional icon name or URL
    }[];
  }[];
}

export const navigationData: NavItem[] = [
  // { label: "Home", link: "/", megaMenu: [] },
  {
    label: "Who We Are",
    link: "/",
    megaMenu: [
      {
        heading: "Company",
        href: "/",
        links: [
          { label: "About Us", href: "/about-us" },
          { label: "Our Team", href: "/konstant-team" },
          { label: "Career", href: "/career" },
          { label: "Contact Us", href: "/contact-us" },
        ],
      },
      {
        heading: "Why Konstant",
        href: "/",
        links: [
          { label: "Client Reviews", href: "/testimonial" },
          { label: "Our Clients", href: "/our-clients" },
          { label: "Our Partners", href: "/our-partners" },
          { label: "Awards & Memberships", href: "/awards-membership" },
          { label: "Press & Media", href: "/media-interviews" },
        ],
      },
      {
        heading: "Our Process",
        href: "/",
        links: [
          {
            label: "Our Development Process",
            href: "/development-methodology",
          },
          { label: "Engagement Models", href: "/engagement-models" },
          {
            label: "Project Communication Strategy",
            href: "/project-communication-strategy",
          },
        ],
      },
      {
        heading: "Partner With Us",
        href: "/",
        links: [
          {
            label: "Associate Partnership",
            href: "/become-a-partner?tab=associate",
          },
          {
            label: "Strategic Partnership",
            href: "/become-a-partner?tab=strategic",
          },
          {
            label: "Referral Partnership",
            href: "/become-a-partner?tab=referral",
          },
        ],
      },
    ],
  },
  {
    label: "Services",
    link: "/services",
    megaMenu: [
      {
        heading: "AI Development",
        href: "/ai-development-company",
        links: [
          {
            label: "Generative AI Development",
            href: "/generative-ai-development",
          },
          {
            label: "AI Chatbot Development",
            href: "/ai-chatbot-app-development",
          },
          {
            label: "AI Agent Development",
            href: "/ai-agent-development-services",
          },
          {
            label: "AI POC Development",
            href: "/mvp-development-services",
          },
          {
            label: "Machine learning",
            href: "/machine-learning-development",
          },
          {
            label: "AI Consulting",
            href: "/ai-consulting-services",
          },
          {
            label: "AI Integration",
            href: "/ai-integration-services",
          },
          {
            label: "Computer Vision Development",
            href: "/computer-vision-development-services",
          },
          {
            label: "AI-Powered Business Transformation",
            href: "/ai-powered-business-transformation/",
          },
          {
            label: "AI-Agent Use Cases",
            href: "/ai-agents/",
          },
        ],
      },
      {
        heading: "Mobile App Development",
        href: "/mobile-application-development",
        links: [
          {
            label: "Cross Platform App Development",
            href: "/cross-platform-app-development",
          },
          {
            label: "Wearable App Development",
            href: "/wearable-app-development",
          },
          {
            label: "App Prototype & Strategy",
            href: "/app-prototyping-strategy",
          },
        ],
      },
      {
        heading: "Web Development",
        href: "/web-development",
        links: [
          {
            label: "Progressive Web App Development",
            href: "/progressive-web-app-development",
          },
          {
            label: "Ecommerce & CMS",
            href: "/ecommerce-web-development",
          },
          {
            label: "Opensource Development",
            href: "/opensource-development",
          },
        ],
      },
      {
        heading: "Metaverse Development",
        href: "/metaverse-development",
        links: [
          { label: "AR Development", href: "/ar-app-development" },
          { label: "VR Development", href: "/virtual-reality-app-development" },
        ],
      },
      {
        heading: "Hire Dedicated Developers",
        href: "/hire-dedicated-developers",
        links: [],
      },
      {
        heading: "Software Maintenance & Support",
        href: "/software-maintenance-support",
        links: [],
      },
      {
        heading: "UI & UX Designing",
        href: "/website-design",
        links: [],
      },
      {
        heading: "For Startups",
        href: "/startup-app-development",
        links: [],
      },
      {
        heading: "For Enterprises",
        href: "/enterprise-app-development",
        links: [],
      },
    ],
  },
  {
    link: "/",
    label: "Technologies",
    megaMenu: [
      {
        heading: "Backend",
        href: "/backend-development",
        links: [
          { label: "NodeJS", href: "/nodejs-development" },
          { label: ".NET", href: "/asp-dotnet-development" },
          { label: "PHP", href: "/php-development" },
          { label: "Python", href: "/python-development-company" },
          { label: "Laravel", href: "/laravel-web-development" },
          { label: "CodeIgniter", href: "/codeigniter-development" },
          { label: "CakePHP", href: "/cakephp-development" },
          { label: "Django", href: "/django-development-company" },
          { label: "Ruby on Rails", href: "/ruby-on-rails-development" },
        ],
      },
      {
        heading: "Frontend",
        href: "/frontend-development",
        links: [
          { label: "Angular", href: "/angular-development" },
          { label: "ReactJS", href: "/reactjs-development" },
          { label: "ThreeJS", href: "/threejs-development-company" },
          { label: "VueJS", href: "/vuejs-development-company" },
          { label: "Full Stack", href: "/hire-full-stack-developer" },
          { label: "MERN Stack", href: "/mern-stack-development-company" },
          { label: "MEAN Stack", href: "/mean-stack-development-company" },
        ],
      },
      {
        heading: "Mobile",
        href: "/",
        links: [
          { label: "iOS", href: "/ios-app-development" },
          { label: "Android", href: "/android-app-development" },
          { label: "React Native", href: "/react-native-app-development" },
          { label: "Java", href: "/java-application-development" },
          { label: "Flutter", href: "/flutter-app-development" },
          { label: "Ionic", href: "/ionic-app-development" },
          { label: "Swift", href: "/swift-app-development" },
          { label: "Kotlin", href: "/kotlin-app-development" },
          { label: ".Net MAUI", href: "/net-maui-app-development" },
          { label: "HTML5", href: "/html5-development" },
        ],
      },
      {
        heading: "Ecommerce",
        href: "/",
        links: [
          { label: "Magento", href: "/magento-development" },
          { label: "Shopify", href: "/shopify-development" },
          { label: "WooCommerce", href: "/woocommerce-development" },
        ],
      },
      {
        heading: "CMS",
        href: "/",
        links: [
          { label: "WordPress", href: "/wordpress-development" },
          { label: "Joomla", href: "/joomla-development" },
          { label: "Odoo", href: "/odoo-development-services" },
          { label: "GCP", href: "/google-cloud-consulting-services" },
          { label: "AWS", href: "/aws-consulting-services" },
          { label: "Stripe", href: "/stripe-integration-services" },
        ],
      },
    ],
  },
  {
    label: "Industries",
    link: "/",
    megaMenu: [
      {
        heading: "Industries We Serve",
        href: "/industries-we-serve",
        links: [
          { label: "Healthcare", href: "/healthcare-app-development" },
          { label: "FinTech", href: "/fintech-app-development" },
          { label: "Transportation", href: "/transportation-app-development" },
          { label: "Food & Restaurant", href: "/restaurant-app-development" },
          { label: "On-Demand Solutions", href: "/on-demand-app-development" },
          {
            label: "Ecommerce, Retail & B2B",
            href: "/ecommerce-app-development",
          },
          { label: "Event & Tickets", href: "/event-app-development" },
          {
            label: "Education & eLearning",
            href: "/elearning-app-development",
          },
          {
            label: "Real Estate & Property",
            href: "/real-estate-app-development",
          },
          { label: "Travel & Hospitality", href: "/travel-app-development" },
          {
            label: "Media & Entertainment",
            href: "/entertainment-app-development",
          },
          { label: "Game Development", href: "/game-app-development" },
          { label: "Fitness", href: "/fitness-app-development" },
          { label: "Social Media", href: "/social-media-app-development" },
          { label: "Logistics", href: "/logistics-app-development" },
          {
            label: "Oil and Gas",
            href: "/oil-and-gas-app-development-services",
          },
          { label: "Automotive", href: "/automotive-app-development-services" },
          {
            label: "Agriculture",
            href: "/agriculture-app-development-services",
          },
          { label: "Sports", href: "/sports-app-development-services" },
          { label: "Insurance", href: "/insurance-mobile-app-development" },
        ],
      },
      {
        heading: "Solutions",
        href: "/",
        links: [
          {
            label: "Food Delivery App",
            href: "/food-delivery-app-development",
          },
          { label: "Chat Solution", href: "/chat-messaging-app-development" },
          { label: "Classified App", href: "/classified-app-development" },
          { label: "Directory App", href: "/directory-app-development" },
          { label: "Dating App", href: "/dating-app-development" },
          {
            label: "Liquor Delivery App",
            href: "/liquor-delivery-app-development",
          },
          {
            label: "Fuel Delivery App",
            href: "/fuel-delivery-app-development",
          },
          { label: "Telemedicine App", href: "/telemedicine-app-development" },
          {
            label: "Doctor On Demand App",
            href: "/doctor-on-demand-app-development",
          },
          {
            label: "Music Streaming App",
            href: "/music-streaming-app-development",
          },
          {
            label: "Fantasy Sports App",
            href: "/fantasy-sports-app-development",
          },
          {
            label: "Electric Vehicle App",
            href: "/electric-vehicle-app-development-services",
          },
          { label: "EV Charging App", href: "/ev-charging-app-development" },
          {
            label: "Magazine And Newspaper App",
            href: "/magazine-and-newspaper-app-development",
          },
          {
            label: "Stock Trading App",
            href: "/stock-trading-app-development",
          },
          { label: "Car Rental App", href: "/car-rental-app-development" },
          { label: "Handyman App", href: "/handyman-app-development" },
          { label: "Laundry App", href: "/laundry-app-development" },
          { label: "Car Wash App", href: "/car-wash-app-development" },
          { label: "EdTech Development App", href: "/edtech-app-development" },
          { label: "Smart TV App", href: "/smart-tv-app-development-services" },
          {
            label: "Flower Delivery App",
            href: "/flower-delivery-app-development",
          },
          {
            label: "Grocery Delivery App",
            href: "/grocery-delivery-app-development",
          },
          {
            label: "Medicine Delivery App",
            href: "/medicine-delivery-app-development",
          },
          {
            label: "Milk Delivery App",
            href: "/milk-delivery-app-development",
          },
          {
            label: "Courier Delivery App",
            href: "/courier-delivery-app-development",
          },
          {
            label: "Video Streaming App",
            href: "/video-streaming-app-development",
          },
          { label: "Taxi App", href: "/taxi-app-development" },
          { label: "OTT App", href: "/ott-app-development" },
        ],
      },
    ],
  },
  {
    label: "Success Stories",
    link: "/success-stories",
    megaMenu: [],
  },
  {
    label: "Resources",
    link: "/",
    megaMenu: [
      {
        heading: "Latest Blogs",
        href: "/blog",
        links: [],
      },
      {
        heading: "White Papers",
        href: "/whitepapers",
        links: [],
      },
      {
        heading: "AI-Agent Use Cases",
        href: "/ai-agents",
        links: [],
      },
    ],
  },
];
